// src/components/RouteRestorer.jsx

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RouteRestorer() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = sessionStorage.getItem("redirectPath");

    if (!redirectPath) return;

    // Remove antes de navegar para evitar loop
    sessionStorage.removeItem("redirectPath");

    // Restaura qualquer caminho salvo
    navigate(redirectPath, {
      replace: true,
    });
  }, [navigate]);

  return null;
}